import { FLT, MMB, CKI, CSS, type PageType } from '@/utils/constants/rip'
import { MMB_ROUTE_NAMES, CKI_ROUTE_NAMES, SELF_SERVICE } from '@/utils/constants/staticPages'

export const usePageType = () => {
  const route = useRoute()

  const pageType = computed<PageType>(() => {
    if (MMB_ROUTE_NAMES.includes(route.path)) {
      return MMB
    }

    if (CKI_ROUTE_NAMES.includes(route.path)) {
      return CKI
    }

    if (SELF_SERVICE.includes(route.path)) {
      return CSS
    }

    return FLT
  })

  return {
    pageType
  }
}
